import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import './index.css'
import { router } from './router'
import reportWebVitals from './reportWebVitals'
import { AuthProvider } from './contexts/AuthContext'
import { initQolaigAudit } from './analytics/qolaigAudit'
import { initSentry, Sentry } from './lib/sentry'

initSentry()
initQolaigAudit()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
  {
    // Remonte à Sentry les erreurs React non rattrapées (sans effet si Sentry est inactif)
    onUncaughtError: Sentry.reactErrorHandler(),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  }
)

root.render(
  <AuthProvider>
    <RouterProvider router={router} />
  </AuthProvider>
)

reportWebVitals()
